import { render, staticRenderFns } from "./DetailListForModal.vue?vue&type=template&id=180e6c12&"
import script from "./DetailListForModal.vue?vue&type=script&lang=js&"
export * from "./DetailListForModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports